import { useModal } from "./ScalarModal.vue_vue_type_script_setup_true_lang.js";
import ScalarModal_default from "./ScalarModal.vue.js";
export { ScalarModal_default as ScalarModal, useModal };
